var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#5CB5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 38.9646L70.302 37.0007L72.7629 31.7637L67.0358 33.6185C65.2116 31.96 62.818 31.0261 60.3244 31C54.7696 31.012 50.2696 35.4012 50.2573 40.8193V43.0014C42.3378 44.5943 35.4251 40.3829 29.0045 33.1821C27.8859 39.0009 29.0045 43.3651 32.3602 46.2745L25 45.1835C25.5869 49.9534 29.5909 53.6292 34.5078 53.9118L28.3557 56.0938C30.5928 60.458 34.6644 61.1344 40.1007 61.549C35.6573 64.505 30.3771 66.031 25 65.9132C53.5459 78.2855 70.302 60.1088 70.302 44.0924V42.2813L75 38.9646Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.77739c431e8f8d2c35bc30e896a88d72.svg";
export { ForwardRef as ReactComponent };